import React from "react";
import {Descriptions} from "antd";

const {Item} = Descriptions;
const SupplierOppInfoSection = ({job, className = "max-w-[55%]", showRates = true, ...props}) => {


    const sharedProps = {
        labelStyle: {fontSize: "0.875rem", lineHeight: '1.25rem', whiteSpace: 'nowrap'},
        contentStyle: {fontWeight: 500, fontSize: "0.875rem", lineHeight: '1.25rem', whiteSpace: 'nowrap'}
    }
    return (
        <div className={className + " text-xs bg-[#F5F6F8] px-2.5 py-2"}>
            <Descriptions size="small" column={2}>
                <Item label="Contract Type" {...sharedProps}>
                    <span className={job.isFixedFee() ? "text-warning-darker" : "text-info"}>
                        {job.contractTypeName()}
                    </span>
                </Item>


                <Item label="Project Duration" {...sharedProps}>
                    {`${TB.moment(job.started_at).format('l')}-${TB.moment(job.ended_at).format('l')}`}
                </Item>

                {showRates && (
                    <Item label="Est Payout" {...sharedProps}>
                        {TB.formatCurrency(job.estimated_payout)}
                    </Item>
                )}

                {!job.isFixedFee() && (
                    <Item label="Avg Hours Per Week" {...sharedProps}>
                        {parseInt(job.avg_hours_per_period || job.total_hours)} hrs
                    </Item>
                )}
                {job.isFixedFee() && (
                    <Item label="# of Deliverables" {...sharedProps}>
                        {job.deliverables?.length || 1}
                    </Item>
                )}

                <Item label="Location" {...sharedProps}>
                    {job.location ? (
                        <span className="text-info">
                            {job.location.city}{!!job.location.state && `, ${job.location.state}`}
                        </span>
                    ) : (
                        !job.required_onsite ? (
                            <span className="text-danger">Remote</span>
                        ) : 'N/A'
                    )}
                </Item>

                <Item label="Est. Total Hours" {...sharedProps}>
                    {parseInt(job.total_hours)} hrs
                </Item>

                <Item label="Contract to Hire Interest?" {...sharedProps}>
                    {job.is_contract_to_hire ? 'Yes' : 'No'}
                </Item>

                <Item label="Required On-Site?" {...sharedProps}>
                    {job.requiredOnSiteDetails()}
                </Item>
            </Descriptions>
        </div>
    )
}

export default SupplierOppInfoSection;